// 顶部消息中心（铃铛=我的通知 / 信封=我的消息）展示映射
// 两块同表：tb_admin_message（后台消息表），接收端视角 = admin_id 0（全体）或 = 当前登录人
//   我的通知（铃铛）→ type=6 后台公告（管理员收到的公告，对应公告模块「管理系统公告」的接收端）
//   我的消息（信封）→ type 1-5 业务提醒：1预约提醒 2核销提醒 3订单提醒 4内容举报 5系统通知
// 数据已接真接口（src/api/mine.js 的 /mine/message*），本文件只留枚举与展示映射。
//
// 界面不暴露表名/字段名，枚举一律经下面这些映射函数出中文。

// ===== 消息类型（type 1-5 业务提醒，type=6 后台公告归「我的通知」） =====

export const MESSAGE_TYPES = [
  { value: 1, label: '预约提醒' },
  { value: 2, label: '核销提醒' },
  { value: 3, label: '订单提醒' },
  { value: 4, label: '内容举报' },
  { value: 5, label: '系统通知' }
]

// 类型 → 中文
export function messageTypeText(value) {
  const item = MESSAGE_TYPES.find(t => t.value === Number(value))
  return item ? item.label : '系统通知'
}

// 类型 → 表格 tagType（举报用 danger 显眼，其余 info）
export function messageTypeTagType(value) {
  return Number(value) === 4 ? 'danger' : 'info'
}

// 阅读状态 → 中文（后端统一口径：点对点与全体公告都返回 is_read；can_read 兜底防御）
export function readText(row) {
  if (!row || Number(row.can_read) !== 1) return '—'
  return Number(row.is_read) === 1 ? '已读' : '未读'
}

// 阅读状态 → tagType
export function readTagType(row) {
  if (!row || Number(row.can_read) !== 1) return 'info'
  return Number(row.is_read) === 1 ? 'info' : 'warning'
}
